import { useFeatureValue } from '@growthbook/growthbook-react';
import mixpanel from 'mixpanel-browser';
import { useEffect, useState } from 'react';

export const useSessionRecordings = () => {
  const enabled = useFeatureValue('mp-session-recordings', false);
  const [initialized, setInitialized] = useState(false);

  useEffect(() => {
    if (!initialized && enabled && process.env.NODE_ENV !== 'development') {
      mixpanel.start_session_recording();
      setInitialized(true);
    }
  }, [enabled, initialized]);
};
